/* snappi tech store: the cart drawer for the Snappi One and Snappi Hi-Fi pages.
   reuse-checked: shopify -- MoneySync is a revenue sync; this is storefront cart JS for a theme asset, not a rebuild of it.
   Real Shopify cart: /cart.js, /cart/add.js, /cart/change.js. Prices on every line come from Shopify (after automatic discounts),
   so what the drawer shows is what checkout charges. The page sets window.SNT before this file loads. */
(function () {
  'use strict';
  var SNT = window.SNT || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: SNT.currency || 'USD' });
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return fmt.format(c / 100); };
  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var drawer = $('#sn-drawer'), list = $('#sn-lines'), more = $('#sn-more'), foot = $('#sn-foot'), live = $('#sn-live');
  var cart = null, subs = [], queue = Promise.resolve(), lastFocus = null;

  function j(path, opts) {
    return fetch(root + path, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { throw d; } return d; });
    });
  }
  function post(path, data) {
    return j(path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) });
  }
  function enqueue(fn) { queue = queue.then(fn, fn); return queue; }
  function take(c) { cart = c; paint(); subs.forEach(function (f) { f(c); }); return c; }
  function load() { return j('cart.js', { headers: { 'Accept': 'application/json' } }).then(take); }
  function has(handle) { return !!cart && cart.items.some(function (i) { return i.handle === handle; }); }
  function isProt(i) { return i.handle === 'shipping-protection'; }
  function qty() { return cart ? cart.items.reduce(function (n, i) { return isProt(i) ? n : n + i.quantity; }, 0) : 0; }
  function protLine() { return cart ? cart.items.filter(isProt)[0] || null : null; }

  /* the card is cheaper with a player: the page's deal prices, then the cart shows what Shopify really charged */
  function cardDeal() {
    var c = SNT.card; if (!c) { return null; }
    var best = null;
    Object.keys(c.deals || {}).forEach(function (h) { if (has(h) && (best === null || c.deals[h] < best)) { best = c.deals[h]; } });
    return best;
  }
  function moreRows() {
    var rows = [];
    [['buds', SNT.buds], ['card', SNT.card]].forEach(function (p) {
      var o = p[1]; if (!o || !o.id || has(o.handle)) { return; }
      if (p[0] === 'card' && (SNT.cards || []).some(function (k) { return has(k.handle); })) { return; }
      var price = o.price, was = o.compare || 0;
      if (p[0] === 'card') { var d = cardDeal(); if (d !== null && d < o.price) { price = d; } if (!was) { was = o.price; } }
      var pct = was > price ? Math.round((1 - price / was) * 100) : 0;
      rows.push('<div class="sn-x"><img src="' + esc(o.image) + '" alt="" width="52" height="52"><div class="sn-xt"><b>' + esc(o.title) + (pct ? '<span class="sn-off">' + pct + '% off</span>' : '') + '</b><span>' +
        (was > price ? '<s>' + money(was) + '</s> ' : '') + '<strong>' + money(price) + '</strong></span></div>' +
        '<button type="button" class="sn-add" data-id="' + o.id + '">Add</button></div>');
    });
    return rows.length ? '<h4>Frequently bought together</h4>' + rows.join('') : '';
  }

  function line(i) {
    var was = i.original_line_price, now = i.final_line_price, cmp = (SNT.cmp || {})[i.variant_id];
    if (cmp && cmp * i.quantity > was) { was = cmp * i.quantity; }
    var sub = i.variant_title && i.variant_title !== 'Default Title' ? '<small>' + esc(i.variant_title) + '</small>' : '';
    return '<div class="sn-l" data-key="' + esc(i.key) + '"><a class="sn-li" href="' + esc(i.url) + '"><img src="' + esc(i.image || '') + '" alt="" width="64" height="64"></a>' +
      '<div class="sn-lt"><a href="' + esc(i.url) + '"><b>' + esc(i.product_title) + '</b></a>' + sub +
      '<div class="sn-q"><button type="button" data-q="-1" aria-label="One fewer">&minus;</button><span aria-live="polite">' + i.quantity + '</span><button type="button" data-q="1" aria-label="One more">+</button>' +
      '<button type="button" class="sn-rm" data-q="0">Remove</button></div></div>' +
      '<div class="sn-lp">' + (was > now ? '<s>' + money(was) + '</s>' : '') + '<b>' + money(now) + '</b></div></div>';
  }

  function paint() {
    if (!cart) { return; }
    var n = qty();
    $$('.cart-n').forEach(function (e) { e.textContent = String(n); });
    $$('.cart-open').forEach(function (e) { e.setAttribute('aria-label', n ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart, empty'); });
    if (!drawer) { return; }
    list.innerHTML = n ? cart.items.filter(function (i) { return !isProt(i); }).map(line).join('') : '<p class="sn-empty">Your cart is empty.</p>';
    var pl = protLine();
    if (!n && pl && !paint.cleaning) { paint.cleaning = true; change(pl.key, 0).then(function () { paint.cleaning = false; }, function () { paint.cleaning = false; }); }
    more.innerHTML = n ? moreRows() : '';
    more.hidden = !more.innerHTML;
    foot.hidden = !n;
    var pbox = $('#sn-prot');
    if (pbox) {
      pbox.hidden = !n || !(SNT.prot && SNT.prot.id);
      if (!pbox.hidden) { $('#sn-pp').textContent = '+' + money(SNT.prot.price); $('#sn-ps').setAttribute('aria-checked', String(!!pl)); $('#sn-ps').disabled = false; }
    }
    if (n) {
      $('#sn-sub').textContent = money(cart.total_price);
      var save = $('#sn-save');
      save.hidden = !(cart.total_discount > 0);
      save.textContent = cart.total_discount > 0 ? 'Includes ' + money(cart.total_discount) + ' off' : '';
    }
  }

  function open() {
    if (!drawer) { return Promise.resolve(); }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('on'); });
    document.documentElement.classList.add('sn-lock');
    var c = $('.sn-close', drawer); if (c) { c.focus(); }
    return Promise.resolve();
  }
  function close() {
    if (!drawer || drawer.hidden) { return; }
    drawer.classList.remove('on');
    document.documentElement.classList.remove('sn-lock');
    setTimeout(function () { drawer.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function add(items) {
    return enqueue(function () {
      return post('cart/add.js', { items: items }).then(load).then(function (c) {
        if (live) { live.textContent = 'Added to your cart. ' + money(c.total_price) + ' total.'; }
        return open();
      });
    });
  }
  function change(key, q) {
    return enqueue(function () { return post('cart/change.js', { id: key, quantity: q }).then(take); });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.sn-close') || t.classList.contains('sn-ov')) { close(); return; }
      var q = t.closest('[data-q]');
      if (q) {
        var row = q.closest('.sn-l'), it = cart.items.filter(function (i) { return i.key === row.getAttribute('data-key'); })[0];
        if (it) { var d = Number(q.getAttribute('data-q')); change(it.key, d === 0 ? 0 : Math.max(0, it.quantity + d)); }
        return;
      }
      var a = t.closest('.sn-add');
      if (a) { a.disabled = true; add([{ id: Number(a.getAttribute('data-id')), quantity: 1 }]).catch(function () { a.disabled = false; }); }
    });
    var ps = $('#sn-ps');
    if (ps) {
      ps.addEventListener('click', function () {
        var pl = protLine(); ps.disabled = true;
        if (pl) { change(pl.key, 0).then(function () { ps.disabled = false; }, function () { ps.disabled = false; }); }
        else if (SNT.prot && SNT.prot.id) { enqueue(function () { return post('cart/add.js', { items: [{ id: SNT.prot.id, quantity: 1 }] }).then(load); }).then(function () { ps.disabled = false; }, function () { ps.disabled = false; }); }
      });
    }
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
    $('#sn-checkout').addEventListener('click', function () { window.location.href = root + 'checkout'; });
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.cart-open')) { e.preventDefault(); load().then(open, open); } });
  document.addEventListener('DOMContentLoaded', paint);

  window.SnappiCart = { add: add, open: open, close: close, load: load, has: has, qty: qty, money: money, onChange: function (f) { subs.push(f); if (cart) { f(cart); } } };
  load().catch(function () {});
})();
